<nav class="sidebar" aria-label="Primary navigation">
  <div class="sidebar-nav">
    <a [routerLink]="['/home', effectiveDeId]" routerLinkActive="active" class="sidebar-nav-item">
      <span class="material-symbols-rounded" aria-hidden="true">home</span>
      <span class="sidebar-label">Home</span>
    </a>

    <a *ngIf="authService.user?.modules?.auditor"
       [routerLink]="['/' + routePaths.riskAssessment + '/' + effectiveDeId]"
       routerLinkActive="active"
       class="sidebar-nav-item">
      <span class="material-symbols-rounded" aria-hidden="true">gpp_maybe</span>
      <span class="sidebar-label">Risk Assessment</span>
    </a>

    <a *ngIf="authService.user?.modules?.insights"
       [routerLink]="['/insights', effectiveDeId]"
       routerLinkActive="active"
       class="sidebar-nav-item">
      <span class="material-symbols-rounded" aria-hidden="true">leaderboard</span>
      <span class="sidebar-label">Enterprise Insights</span>
    </a>

    <a *ngIf="authService.user?.modules?.variance"
       [routerLink]="['/variance', effectiveDeId]"
       routerLinkActive="active"
       class="sidebar-nav-item">
      <span class="material-symbols-rounded" aria-hidden="true">flag_circle</span>
      <span class="sidebar-label">Variance</span>
    </a>

    <a *ngIf="authService.user?.modules?.p2p"
       [routerLink]="getP2pLink()"
       routerLinkActive="active"
       class="sidebar-nav-item">
      <span class="material-symbols-rounded" aria-hidden="true">groups</span>
      <span class="sidebar-label">Peer Analytics</span>
    </a>

    <a tabindex="0"
       role="button"
       *ngIf="authService.user?.modules?.waste && enableAssayManagement"
       (click)="authenticateWitness()"
       (keydown.enter)="authenticateWitness()"
       (keydown.space)="authenticateWitness(); $event.preventDefault()"
       class="sidebar-nav-item">
      <span class="material-symbols-rounded" aria-hidden="true">biotech</span>
      <span class="sidebar-label">Assay Management</span>
    </a>
  </div>
</nav>

<app-witness-authentication #witnessAuthDialog
                            *ngIf="authService.user?.modules?.waste && enableAssayManagement"
                            [deId]="effectiveDeId"
                            (showPincodeUpdate)="showPincodeUpdateModal()">
</app-witness-authentication>

<app-update-pin #updatePinDialog
                *ngIf="authService.user?.modules?.waste && enableAssayManagement">
</app-update-pin>
